module.exports = __webpack_public_path__ + "img/logo.ac34244e.svg";